import { MouseEventHandler, ReactNode, ReactElement } from "react";
import { SkeletonProps } from "../../global.props";

/**
 * @deprecated
 */
export enum SortOrder {
  Asc = "asc",
  Desc = "desc",
}

/**
 * @deprecated
 */
export interface SortOptions {
  readonly [column: string]: SortOrder;
}

/**
 * @deprecated
 */
export interface QueryOptions {
  readonly order_by: SortOptions[];
  readonly results_per_page: number;
  readonly page_number: number;
}

/**
 * @deprecated
 */
export type HandleUpdateRequest = (option: QueryOptions) => void;

/**
 * @deprecated
 */
export interface BulkActions<DataProp> {
  [key: string]: (rows: DataProp[]) => void;
}

/**
 * @deprecated
 */
export type Paginate = {
  /**
   * Turns on/off pagination
   */
  readonly paginate?: boolean;
};

/**
 * @deprecated
 */
export interface TableHeaderProps<DataProp> {
  /**
   * The headers key
   */
  readonly key?: string | undefined;

  /**
   * The headers labels
   */
  readonly label?: string | undefined | ReactElement | null;

  /**
   * Onclick for headers
   */
  readonly headerOnClick?: MouseEventHandler;

  /**
   * Custom Cell
   */
  readonly cell?: (data: DataProp) => ReactNode;

  /**
   * format label ie. time/ date
   */
  // eslint-disable-next-line
  readonly formatter?: (value: any) => string | number;

  /**
   * Set if you want the column to be sortable
   * default is True
   */
  readonly sortable?: boolean;
}

/**
 * @deprecated Use `import { TableProps } from capitalrx-components-2.0/lib/general` instead.
 */
export interface TableProps<DataProp> extends SkeletonProps, Paginate {
  /**
   * The data table test id
   */
  readonly id?: string;

  /**
   * The test id of the icon
   */
  readonly testId?: string | undefined;

  /**
   * the actual data
   */
  readonly data: DataProp[];

  /**
   * used to filter / name the columns
   */
  readonly headers: TableHeaderProps<DataProp>[];

  /**
   * the options to use in the query, such as results per page, order_by,  page_number
   */
  readonly queryOptions?: QueryOptions;

  /**
   * Handles update request
   */
  readonly handleUpdateRequest?: HandleUpdateRequest;

  /**
   * function used to change sort order when a header column is clicked
   */
  readonly handleChangeSortOrder?: (data: QueryOptions) => void;

  /**
   * how many total results there were sent back from the API
   */
  readonly resultsTotalCount?: number | string;

  /**
   * Show the Bulk Actions select?
   */
  readonly bulkActions?: BulkActions<DataProp>;

  /**
   * The row onClick action
   */
  readonly handleRowClick?: (e: React.MouseEvent<HTMLTableRowElement>, data: DataProp) => void;

  /**
   * The className
   */
  readonly className?: string;

  readonly paginatePosition?: "top" | "bottom" | "all";
}

/**
 * @deprecated
 */
export interface ColumnsProps<DataProp> {
  readonly headers: TableHeaderProps<DataProp>[];
  readonly handleUpdateRequest?: HandleUpdateRequest;
  readonly handleColumnClick?: Function;
  readonly queryOptions?: QueryOptions;
  readonly resetTable: () => void;
  readonly testId?: string | undefined;
}

/**
 * @deprecated
 */
export interface RowsProps<DataProp> {
  readonly formattedData: { [key: string]: string | number | ReactNode | null }[];
  /**
   * the actual data
   */
  readonly data: DataProp[];
  readonly handleRowClick?: (e: React.MouseEvent<HTMLTableRowElement>, data: DataProp) => void;
  readonly resetTable: () => void;
  readonly testId?: string | undefined;
}

/**
 * @deprecated
 */
export interface TableWrapperProps<DataProp> {
  readonly testId?: string | undefined;
  readonly bulkActions?: BulkActions<DataProp> | undefined;
  readonly handleBulkActionsApply?: ((selectedFunction: string) => void) | undefined;
  readonly paginate?: boolean | undefined;
  readonly resultsTotalCount?: number | undefined;
  readonly queryOptions?: QueryOptions | undefined;
  readonly handleUpdateRequest?: HandleUpdateRequest | undefined;
  readonly children: ReactNode;
  readonly resetTable: () => void;
  readonly paginatePosition?: "top" | "bottom" | "all";
  readonly resultsMoreFlag?: boolean | undefined;
}

/**
 * @deprecated
 */
export interface TableBulkActionProps<DataProp> {
  readonly bulkActions: BulkActions<DataProp>;
  readonly handleBulkActionsApply: (selectedFunction: string) => void;
  readonly paginate: boolean;
}
